<template>
  <TemplateView>
    <div class="container">
      <TemplatePageGrid
        :items="workDocsDocumentTypeGrid"
        :page-data="pageData"
        :loading="loadingAnimation"
      >
        <template v-slot:buttons>
          <WorkDocsDocumentTypeModal
            v-if="$userCheckAccess({ abilities: 'edit_document_types' })"
            create
          />
        </template>
        <WorkDocsDocumentTypeTable :items="workDocsDocumentTypeGrid" />
      </TemplatePageGrid>
    </div>
  </TemplateView>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import TemplateView from 'components/templates/TemplateView'
import TemplatePageGrid from 'components/templates/TemplatePageGrid'
import WorkDocsDocumentTypeTable from 'components/setting/workDocsDocumentType/WorkDocsDocumentTypeTable'
import WorkDocsDocumentTypeModal from 'components/setting/workDocsDocumentType/WorkDocsDocumentTypeModal'

export default {
  name: 'WorkDocsDocumentType',
  components: {
    TemplateView,
    TemplatePageGrid,
    WorkDocsDocumentTypeTable,
    WorkDocsDocumentTypeModal,
  },
  data() {
    return {}
  },
  created() {
    this.downloadPageData()
  },
  watch: {
    '$route.query'() {
      this.downloadPageData()
    },
  },
  computed: {
    ...mapGetters('workDocsDocumentType', ['workDocsDocumentTypeGrid', 'pageData']),
    ...mapGetters(['loadingAnimation']),
  },
  methods: {
    ...mapActions('workDocsDocumentType', ['onWorkDocsDocumentTypeGrid']),
    downloadPageData() {
      let data = {
        limit: this.$route.query.limit,
        page: this.$route.query.page,
      }
      if (this.$route.query.sort_param && this.$route.query.sort_value) {
        data.sort = {
          param: this.$route.query.sort_param,
          value: this.$route.query.sort_value,
        }
      }
      if (this.$route.query.search) {
        data.search = this.$route.query.search
      }
      this.onWorkDocsDocumentTypeGrid(data)
    },
  },
}
</script>
